<template>
  <div>
    <div class="row">
      <loading
        :active.sync="loading"
        color="#556ee6"
        loader="dots"
        :can-cancel="false"
        :is-full-page="false">
      </loading>
      <div class="col-lg-12">
        <div v-if="!loading && actions.length === 0" class="text-center text-muted py-4">
          Nenhuma ação de retorno para este participante.
        </div>
        <div v-else>
          <table class="table table-hover mb-0">
            <thead>
              <tr>
                <th width="40%">Regra</th>
                <th width="20%">Status</th>
                <th width="25%">Expira em</th>
                <th width="15%" class="text-right">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="action in actions" :key="action.id">
                <td>{{ action.follow_up_rule ? action.follow_up_rule.name : '-' }}</td>
                <td>
                  <span class="badge" :class="statusBadge(action.status)">
                    {{ statusLabel(action.status) }}
                  </span>
                </td>
                <td>
                  <span :class="{ 'text-danger': isExpired(action) }">
                    {{ action.expires_at ? $moment(action.expires_at).format('DD/MM/YYYY HH:mm') : '-' }}
                  </span>
                  <small v-if="isExpired(action)" class="text-danger d-block">expirado</small>
                </td>
                <td class="text-right">
                  <div v-if="action.status === 'pending'" class="dropdown d-inline-block">
                    <button
                      type="button"
                      class="btn btn-link p-0 text-muted"
                      title="Ações"
                      @click.stop="toggleMenu(action.id)">
                      <i class="bx bx-dots-vertical-rounded font-size-18"></i>
                    </button>
                    <div
                      class="dropdown-menu dropdown-menu-right"
                      :class="{ show: openMenuId === action.id }">
                      <a
                        v-if="action.action_url"
                        href="#"
                        class="dropdown-item"
                        @click.prevent="copyLink(action.action_url)">
                        <i class="bx bx-copy mr-1"></i> Copiar link
                      </a>
                      <a
                        href="#"
                        class="dropdown-item"
                        :class="{ disabled: resending[action.id] }"
                        @click.prevent="resendLink(action.id)">
                        <i class="bx bx-mail-send mr-1"></i> Reenviar
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { list as listActions, resend as resendAction } from '@/pages/pending-actions/services'

export default {
  components: {
    Loading
  },
  props: {
    idParticipant: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      loading: true,
      actions: [],
      resending: {},
      openMenuId: null
    }
  },
  beforeMount () {
    this.fetch()
  },
  mounted () {
    document.addEventListener('click', this.closeMenu)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.closeMenu)
  },
  methods: {
    toggleMenu (id) {
      this.openMenuId = this.openMenuId === id ? null : id
    },
    closeMenu () {
      this.openMenuId = null
    },
    async fetch () {
      this.loading = true
      try {
        const res = await listActions({ participant_id: this.idParticipant, limit: 100 })
        // index() retorna paginação Laravel: { data: { data: [...] } }
        this.actions = (res.data && res.data.data) ? res.data.data : []
      } catch (error) {
        errorMessage('Erro ao carregar ações de retorno.')
      } finally {
        this.loading = false
      }
    },
    async resendLink (id) {
      if (this.resending[id]) return
      this.closeMenu()
      this.$set(this.resending, id, true)
      try {
        await resendAction(id)
        successMessage('Link reenviado com sucesso.', 2500)
        await this.fetch()
      } catch (error) {
        const msg = (error.response && error.response.data && error.response.data.message)
          ? error.response.data.message
          : 'Erro ao reenviar link.'
        errorMessage(msg)
      } finally {
        this.$set(this.resending, id, false)
      }
    },
    async copyLink (url) {
      this.closeMenu()
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(url)
        } else {
          // Fallback para navegadores/contextos sem Clipboard API (ex.: http)
          const el = document.createElement('textarea')
          el.value = url
          el.style.position = 'fixed'
          el.style.opacity = '0'
          document.body.appendChild(el)
          el.select()
          document.execCommand('copy')
          document.body.removeChild(el)
        }
        successMessage('Link copiado para a área de transferência.', 2000)
      } catch (e) {
        errorMessage('Não foi possível copiar o link.')
      }
    },
    statusLabel (status) {
      const labels = {
        pending: 'Pendente',
        submitted: 'Aguardando revisão',
        approved: 'Aprovada',
        rejected: 'Rejeitada'
      }
      return labels[status] || status
    },
    statusBadge (status) {
      const badges = {
        pending: 'badge-warning',
        submitted: 'badge-info',
        approved: 'badge-success',
        rejected: 'badge-danger'
      }
      return badges[status] || 'badge-secondary'
    },
    isExpired (action) {
      return action.expires_at && this.$moment(action.expires_at).isBefore(this.$moment())
    }
  }
}
</script>
